import { styled } from '@mui/system';
import { Typography } from '@mui/material';

export const StatusText = styled(Typography)(({ status = 'info', theme }) => {
  switch (status) {
    case 'info':
      return { color: theme.palette.info.main };
    case 'success':
      return { color: theme.palette.success.main };
    case 'warning':
      return { color: theme.palette.warning.main };
    case 'error':
      return { color: theme.palette.error.main };
    case 'tempo-suggestion':
      return {
        background: 'linear-gradient(90deg, #FF7998 0.29%, #C73B86 32.16%, #871D75 57.6%, #C73B86 74.27%)',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          opacity: 0.9,
        },
      };
    default:
      return { color: theme.colors.gray };
  }
});
